import React from "react";
import { User, Users } from "lucide-react";

/**
 * Reusable component for Player Name inputs.
 * Handles layout changes between PvP and PvC modes.
 */
const PlayerNameInput = ({
  player1Name,
  setPlayer1Name,
  player2Name,
  setPlayer2Name,
  gameMode,
}) => {
  return (
    <div
      className={`
        max-w-lg mx-auto mb-6 border-t pt-6
        ${
          gameMode === "PvP"
            ? "grid grid-cols-1 md:grid-cols-2 gap-4"
            : "flex justify-center"
        }
      `}
    >
      <div className={gameMode === "PvC" ? "w-full max-w-xs" : "w-full"}>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center">
          <User className="w-4 h-4 mr-1 text-blue-500" />
          Player 1 Name:
        </label>
        <input
          type="text"
          value={player1Name}
          onChange={(e) => setPlayer1Name(e.target.value)}
          placeholder="Enter Player 1 name"
          className="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all"
        />
      </div>

      {gameMode === "PvP" && (
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center">
            <Users className="w-4 h-4 mr-1 text-red-500" />
            Player 2 Name:
          </label>
          <input
            type="text"
            value={player2Name}
            onChange={(e) => setPlayer2Name(e.target.value)}
            placeholder="Enter Player 2 name"
            className="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all"
          />
        </div>
      )}
    </div>
  );
};

export default PlayerNameInput;
